exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".suggestBox[data-v-6b512fec]{width:calc(80% - 3rem)}", ""]);

// exports
